/** An Element Click Event */
export default class Click extends CustomEvent {
    constructor(caller) {
        super('click', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
